/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Clients_Filter_Selected_CountInputs */

const en_clients_filter_selected_count = /** @type {(inputs: Clients_Filter_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const pt_br2_clients_filter_selected_count = /** @type {(inputs: Clients_Filter_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selecionado(s)`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Clients_Filter_Selected_CountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_filter_selected_count = /** @type {((inputs: Clients_Filter_Selected_CountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Filter_Selected_CountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_filter_selected_count(inputs)
	return pt_br2_clients_filter_selected_count(inputs)
});